import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const BlogPostsSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("BlogPostsSelect", true))
);

export default BlogPostsSelectMultipleTester;
